import { motion } from 'framer-motion'

import Img from './assets/sprites/Frame 8.webp'
import { useScrollingOrnament } from './useScrollingOrnament'

const SLIDES_COUNT = 11
const VIEWPORT_HEIGHT = 59
const OFFSET = 4

export const Ornament4 = () => {
  const { ref, slideNum } = useScrollingOrnament(
    SLIDES_COUNT,
    VIEWPORT_HEIGHT,
    OFFSET
  )

  return (
    <div ref={ref}>
      <svg
        viewBox={`0 0 753 ${VIEWPORT_HEIGHT - 2}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.image href={Img} width="753" x="0" y={slideNum} />
      </svg>
    </div>
  )
}
